import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import Filter from "../../../components/elements/Filter";
import { getFormByFilter } from "../../../store/middleware";
import CardReport from "../../../components/report/CardReport";
import { clearReportStatus } from "../../../store/slices/methodology.slice";

const optionsPeriodFilter = ["day", "week", "month"];
const optionsStatusFilter = ["pendent", "done", "delayed"];

const ContentCardReport = ({ teacherId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const { user } = useSelector((state) => state.userReducer);
  const { reportAll } = useSelector((state) => state.methodologyReducer);

  const [filter, setFilter] = useState({ status: "", period: "" });

  const filters = [
    {
      type: "select",
      name: "status",
      label: "Status",
      placeholder: "Select",
      value: filter.status,
      options: optionsStatusFilter.map((option) => ({ id: option, name: t(option.toLocaleUpperCase()) })),
    },
    {
      type: "select",
      name: "period",
      label: "Periodo",
      placeholder: "Select",
      value: filter.period,
      options: optionsPeriodFilter.map((option) => ({ id: option, name: t(option.toLocaleUpperCase()) })),
    },
  ];

  const inputChange = (e, name) => {
    const { value } = e.target;
    setFilter((prevState) => ({ ...prevState, [name]: value }));
  };

  const applyFilters = () => {
    getData(filter);
    setFilter(filter);
  };

  const clearFilters = (e) => {
    e.preventDefault();

    setFilter({ status: "", period: "" });
    getData({ status: "", period: "" });
  };

  const getData = async (payloadParams) => {
    const payload = { ...payloadParams, teacherId: user?.role === "teacher" ? user?.teacherId : teacherId };
    await dispatch(getFormByFilter(payload));
  };

  useEffect(() => {
    getData();
    dispatch(clearReportStatus());
    // eslint-disable-next-line
  }, [teacherId]);

  return (
    <>
      <Filter filters={filters} clear={clearFilters} submit={applyFilters} inputChange={inputChange} />

      {reportAll?.map((methodology, index) => {
        const methodologyFormatted = methodology?.map((item) => ({
          ...item,
          checkIfFirstClass: item.cycleAndLevel.length === 0 ? true : item.checkIfFirstClass,
        }));

        return <CardReport key={index} data={methodologyFormatted} />;
      })}
    </>
  );
};

export default ContentCardReport;
